import { useCallback } from 'react';

import { useNavigate } from 'react-router-dom';

import { routes } from 'utils/routing';

// Deep link into the native TH app's home. The default return target, since
// the linking flow is overwhelmingly app-initiated.
export const TH_APP_HOME_DEEP_LINK = 'timhortons://home';

/**
 * Returns a "back to Tim Hortons" handler shared across the partner-linking
 * screens (initiate redirect, already-linked, rate-limited, error).
 *
 * A confirmed app origin deep-links into the native app; everything else —
 * incl. an unknown/missing origin — navigates to the TH web home. Web home
 * is the safe default: a deep link no-ops on a desktop without the app, and
 * users can start linking from TH on the web too.
 */
export function useBackToApp(isAppOrigin: boolean): () => void {
  const navigate = useNavigate();

  return useCallback(() => {
    if (isAppOrigin) {
      // Hard navigation (not `navigate()`) because the URL scheme is
      // non-HTTP and the OS handles the handoff to the installed app. If the
      // app is missing, the browser surfaces its native fallback UX; we
      // intentionally don't try to detect-and-redirect here.
      window.location.assign(TH_APP_HOME_DEEP_LINK);
      return;
    }
    navigate(routes.base);
  }, [isAppOrigin, navigate]);
}
